export var ErrorType;
(function (ErrorType) {
    ErrorType["INTERNAL"] = "-1";
    ErrorType["FOLIO_EXTERNAL_OR_UNDEFINED"] = "-2";
    ErrorType["EXTERNAL_OR_UNDEFINED"] = "-3";
    ErrorType["UNKNOWN"] = "-4";
    ErrorType["AUTHENTICATION_EMAIL_NOT_VALID"] = "-5";
    ErrorType["AUTHENTICATION_PASSWORD_NOT_VALID"] = "-6";
    ErrorType["AUTHENTICATION_USER_DOES_NOT_BELONG_TO_ORGANIZATION"] = "-7";
    ErrorType["VALIDATION_ERROR"] = "-8";
    ErrorType["DUPLICATE_EMAIL"] = "-9";
    ErrorType["VALIDATION_ROLE_EXCLUSIVITY"] = "-10";
    ErrorType["VALIDATION_COMPANY_NUMBER_INVALID"] = "-11";
    ErrorType["VALIDATION_ORGANIZATION_COMPANY_NUMBER_ALREADY_EXISTS"] = "-12";
    ErrorType["VALIDATION_ROLE_NOT_ALLOWED_IN_ORGANIZATION"] = "-13";
})(ErrorType || (ErrorType = {}));
